import { SVGProps, memo } from 'react';

const ChatIcon= (props: SVGProps<SVGSVGElement>) => (

    <svg width={props.width || "15"} height={props.height || "15"} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.12705 10.5478L10.9952 12.2635L10.4831 10.541L11.4392 9.99304C12.701 9.26975 13.5453 7.91836 13.5453 6.37261C13.5453 4.06671 11.6649 2.1974 9.34531 2.1974H6.54531C4.22572 2.1974 2.34531 4.06671 2.34531 6.37261C2.34531 8.67852 4.22572 10.5478 6.54531 10.5478H8.12705ZM0.945312 6.37261C0.945312 3.29807 3.45252 0.805664 6.54531 0.805664H9.34531C12.4381 0.805664 14.9453 3.29807 14.9453 6.37261C14.9453 8.43596 13.8161 10.2371 12.1385 11.1987L12.9148 13.8097C13.1323 14.5413 12.2655 15.1108 11.6737 14.6251L7.6238 11.9396H6.54531C3.45252 11.9396 0.945312 9.44715 0.945312 6.37261Z" fill={props.fill || "black"} fill-opacity={props.fillOpacity ||   "0.87"}/>
    </svg>

);

export default memo(ChatIcon);
